module.exports = __webpack_public_path__ + "img/491-20e618.png";